export const PAGE_BUTTON_CLICK = "PAGE_BUTTON_CLICK";
export const PAGE_MOVE_INDEX = "PAGE_MOVE_INDEX";

export const SCROLL_MOVING_TRUE = "SCROLL_MOVING_TRUE";
export const ABOUT_PAGE_SCROLL_TRUE = "ABOUT_PAGE_SCROLL_TRUE";
export const PASSION_BG_COLOR_CHANGE = "PASSION_BG_COLOR_CHANGE";
export const PASSION_PAGE_ENTER = "PASSION_PAGE_ENTER";
